<template>
  <!-- spa和ssr共用的全景漫遊展示組件 -->
  <div style="height: 100%">
    <transition name="slide-fade">
      <div class="splash" v-show="!passwordVisible && isShowSplash && !isVrTalk"
        :style="{ 'background-image': 'url(' + cover + ')' }">
        <!--        <img :src="cover" />-->
      </div>
    </transition>
    <!-- 過期提示框 -->
    <div class="overdue-tips-box" v-if="isOverdue">
      <div class="box-content">
        <div class="close-btns" @click="isOverdue = false">
          <a-icon class="icon-ants" type="plus" />
        </div>
        <div class="tops"><img src="../../static/images/overdue.png" /></div>
        <div class="bottoms">
          <h1>{{ $t("common.renewAlert") }}</h1>
          <p>{{ $t("common.renewInfo2") }}</p>
        </div>
      </div>
    </div>

    <div class="fullscreen-wrap" :class="newWork.menus.length &&
      judgeMobile() &&
      btnsVisible &&
      !isVrTalk
      ? 'hasMenu'
      : ''
      " v-show="!loadingState && !passwordVisible && !isShowSplash">
      <div v-if="pano3dVisible" id="pano3d" style="width: 100%; height: 100%"></div>
      <!--/*      <div id="pano" style="width: 100%; height: 100%; z-index: -1;"></div>*/-->
      <div class="pano-box" :style="panoBoxStyle">
        <div id="pano2" :style="pano2Style" @mousedown="setActivePano('pano2')"></div>

        <div id="pano" :style="panoStyle" @mousedown="setActivePano('pano')">
        </div>
      </div>
      <div class="vrshow_tour_btn_wrap" id="tour_btn_wrap" v-show="tourGuideState > 0">
        <div class="vrshow_tour_btn_oper" style="margin-right: 20px">
          <span class="btn_tour_text" @click="pauseTourGuide" v-if="tourGuideState == 1">{{ $t("tour.actionTitles.pause")
          }}</span>
          <span class="btn_tour_text" @click="resumeTourGuide" v-if="tourGuideState == 2">{{ $t("tour.actionTitles.play")
          }}</span>
        </div>
        <div class="vrshow_tour_btn_oper">
          <span class="btn_tour_text" @click="stopTourGuide">{{
            $t("tour.actionTitles.stop")
          }}</span>
        </div>
      </div>

      <div id="panoBtns" v-show="btnsVisible">
        <div v-show="outSandShow">
          <!-- 浮水印 -->
          <div v-show="vrbase.base.is_water && vrbase.base.is_water === 1" class="watermark">
            <img v-if="vrbase.water_logo_url && vrbase.water_logo_url !== ''" :src="vrbase.water_logo_url" alt="watermark" style="width: 500px;opacity: 0.2">
            <!-- <img v-else :src="qwhouseLogo" alt="watermark" style="width: 500px;opacity: 0.2"> -->
          </div>
          <!-- 跑馬燈 -->
          <div class="marquee" v-if="isMarqueeVivsble &&
            !passwordVisible &&
            !isShowSplash &&
            !isVrTalk
            ">
            <marquee-box :text="newWork.ads.top_ad"></marquee-box>
          </div>
          <!-- logo -->
          <div v-if="!isVrTalk" class="vrshow_container_logo" :style="{ top: isMarqueeVivsble ? '40px' : '10px' }">
            <img v-show="newWork.ads.logo != ''" :src="newWork.ads.logo" />
            <div class="vrshow_logo_title" id="user_name_wrap"
              v-show="newWork.sets.hideuser === 0 && newWork.ads.author != ''">
              <div id="authorDiv">
                {{ $t("tour.author") }}：
                <span id="user_nickName">{{ newWork.ads.author }}</span>
              </div>
              <div style="clear: both"></div>
            </div>

            <div class="vrshow_logo_title" v-show="newWork.sets.hidebrowse === 0">
              <div id="viewnumDiv">
                {{ $t("descriptions.popular") }}：
                <span id="user_viewNum">{{ newWork.base.total_browse }}</span>
              </div>
              <div style="clear: both"></div>
            </div>
            <div @click="showThingBase" v-if="showBaseBtnByMobile && newWork.base.thing_no"
              :style="newWork.base.store_type == 1 ? 'background-color:#920783;' : 'background-color:#22b24c;'" style="background-color: #22b24c;margin-top: 53px;width: 70px;font-size: 10px;color: #ffffff;
                 border-radius: 10px;display: flex;justify-content: center;align-items: center;padding: 3px 0">
              基本資料
            </div>
          </div>
          <!-- 右上方全屏、音樂、沙盤等操作圖標 -->
          <div class="vrshow_container_1_min" :style="{ top: actionBtnH }">
            <!--<div
              :class="isBtnMenu?'btn_fullmenu':'btn_menu'"
              v-if="newWork.menus.length"
              @click="toggleBtnMenu"
            ></div>-->
            <div v-if="!isVrTalk" :class="isFullscreen ? 'btn_fullscreen_off' : 'btn_fullscreen'"
              @click="toggleFullscreen" v-show="newWork.sets.hidefullscreen === 0 && fullscreenVisible" title></div>
            <div v-if="!isVrTalk" class="btn_vrmode" @click="showWebVR"
              v-show="newWork.sets.hidevr === 0 && webvrVisible"></div>
            <div v-show="newWork.sets.hidebgm === 0 && musicVisible">
              <div class="btn_bgmusic" @click="toggleMusic(false)" v-if="musicState"></div>
              <div class="btn_bgmusic_off" @click="toggleMusic(true)" v-if="!musicState"></div>
            </div>
            <div v-show="newWork.sets.hidebgv === 0 && speechVisible">
              <div class="btn_speck" @click="toggleSpeech(false)" v-if="speechState"></div>
              <div class="btn_speck_off" @click="toggleSpeech(true)" v-if="!speechState"></div>
            </div>
            <div v-show="gyroVisible" v-if="!isVrTalk">
              <div class="btn_gyro" @click="toggleGyro(false)" v-if="gyroState"></div>
              <div class="btn_gyro_off" @click="toggleGyro(true)" v-if="!gyroState"></div>
            </div>

            <div v-show="newWork.sets.auto_rotate == 0" v-if="!isVrTalk">
              <div class="btn_rotate" @click="toggleRotate(false)" v-if="rotateState"></div>
              <div class="btn_rotate_off" @click="toggleRotate(true)" v-if="!rotateState"></div>
            </div>

            <a v-show="radarVisible" @click="toggleKrpSandTable">
              <img v-if="isSandSceneVisible" src="../../static//images/skin1/radar_open.png" class="vrshow_radar_btn" />
              <img v-else src="../../static/images/skin1/radar.png" class="vrshow_radar_btn" />
            </a>
          </div>
          <!-- 一鍵導覽 -->
          <div class="vrshow_tour_btn" :style="{
            bottom: '15px',
          }" v-show="newWork.guide.length > 0 &&
  newWork.guide[0].points.length > 0 &&
  !isVrTalk
  " @click="startTourGuide">
            <span class="btn_tour_text">{{
              $t("tour.actionTitles.quickGuide")
            }}</span>
          </div>
          <!-- 說一說、簡介、分享等 -->
          <div class="vrshow_container_2_min" v-if="!isVrTalk">
            <div class="img_desc_container_min" id="comment_div" v-show="newWork.sets.hidecomment === 0">
              <img src="../../static/images/skin1/vr-btn-comment.png" @click="show_comment" />
              <div class="img_desc_min">{{ $t("tour.msg.title") }}</div>
            </div>
            <!-- <div class="img_desc_container_min" id="praiseDiv">
                <img id="btnpraise" src="/images/skin1/vr-btn-good.png" onclick="addPraise(this)" />
                <div class="img_desc_min" id="praisedNum">0</div>
            </div>-->
            <div class="img_desc_container_min" v-if="newWork.sets.hideintroduce == 0" id="profileDiv">
              <img src="../../static/images/skin1/vr-btn-desc.png" @click="showProfile()" />
              <div class="img_desc_min">{{ $t("descriptions.briefInfo") }}</div>
            </div>
            <div class="img_desc_container_min" id="shareDiv" v-show="newWork.sets.hideshare === 0">
              <img src="../../static/images/skin1/vr-btn-share.png" @click="showShareQr" />
              <div class="img_desc_min">{{ $t("actionTitles.share") }}</div>
            </div>
          </div>
          <!-- ai主播 -->
          <ai-anchor ref="playAi" :sceneList="Object.values(newWork.scenes)" :aiAnchorHeight="aiAnchorHeight" />
          <!-- 場景選擇 -->
          <div v-if="sceneShow && !isVrTalk" class="vrshow_container_3_min">
            <div class="img_desc_container_min scene-choose-width" v-show="newWork.sets.hidechoose == 0">
              <a href="javascript:void(0);" @click="toggleShowthumbs">
                <img src="../../static/images/skin1/vr-btn-scene.png" />
              </a>
              <div class="img_desc_min">{{ $t("common.sceneSelect") }}</div>
            </div>
            <div class="img_desc_container_min scene-choose-width" v-show="tongPingIsShow">
              <a href="javascript:void(0);" @click="clickTongPing">
                <img src="../../static/images/skin1/tong-ping.png" />
              </a>
              <div class="img_desc_min">對比圖</div>
            </div>
            <div class="img_desc_container_min scene-choose-width" v-show="newWork.sets.hidechoose == 0 && isPano3d">
              <a href="javascript:void(0);" @click="showPano3d">
                <img src="../../static/images/skin1/vr-btn-house.png" />
              </a>
              <div class="img_desc_min">{{ $t("common.pano3d") }}</div>
            </div>
          </div>
          <!--縮略圖列表-->
          <ThumbSwiper ref="thumbList" :krpanoObj="krpanoObj" :groupList="group_List" :isPano3d="isPano3d"
            @showPano3d="showPano3d" v-show="newWork.sets.hidechoose == 0"></ThumbSwiper>
        </div>
        <!-- 沙盤場景 -->
        <div ref="sandBoxTour" :style="{ top: spTop }" class="sand-box-tour-base" v-if="isSandSceneVisible">
          <ImageDrawer mode="tour" v-on:sandTableZoomIn="sandTableZoomIn" :isShowZoom="true" :visible="isSandSceneVisible"
            :initHeight="sandTableHeight"></ImageDrawer>
        </div>
      </div>
    </div>

    <!-- 選單欄 -->
    <div class="vrshow_container_menu" :style="{ top: menuTop() }" v-if="newWork.menus.length &&
      btnsVisible &&
      !loadingState &&
      !passwordVisible &&
      !isShowSplash &&
      !isVrTalk
      ">
      <!--          :class="isBtnMenu?'opend':''"-->
      <span v-for="item in newWork.menus" :key="item.id" :style="{
        width: newWork.menus.length && judgeMobile() ? setWidth() : 'auto',
      }">
        <a :href="item.content" target="_blank" v-if="item.type === 1">
          <span>{{ item.title }}</span>
        </a>
        <a :href="'tel:' + item.content" v-if="item.type === 2">
          <span>{{ item.title }}</span>
        </a>
        <a
          v-if="item.type === 3 && item.content.latLng"
          target="_blank"
          :href="`https://www.google.com/maps/search/?api=1&query=${item.content.latLng.lat},${item.content.latLng.lng}`"
        >
          <span>{{ item.title }}</span>
        </a>
        <a
          v-if="item.type === 3 && !item.content.latLng"
          target="_blank"
          :href="`https://www.google.com/maps/search/?api=1&query=${item.content}`"
        >
          <span>{{ item.title }}</span>
        </a>
        <a href="javascript:void(0);" @click="showPictextHotspot(item.title, item.content)" v-if="item.type === 4">
          <span>{{ item.title }}</span>
        </a>
        <a href="javascript:void(0);" @click="showVideoHotspot(item.content.url, item)" v-if="item.type === 5">
          <span>{{ item.title }}</span>
        </a>
      </span>
    </div>
    <WordViewer :visible="wordHotspotVisible" :title="wordHotspotTitle" :content="wordHotspotContent"
      @close="closeWordHotspot"></WordViewer>
    <FullSandbox :visible="isSandFull" @closeFull="closeFullImage"></FullSandbox>
    <!--
    <div class="hotspot-images" v-viewer="{movable: false, title: false}" v-show="false">
      <img v-for="src in images" :src="src" :key="src" />
    </div>
    -->
    <div id="imgHotspotBox" style="display: none; position: absolute; left: 0; top: 0"></div>
    <a-modal v-model="linkHotspotVisible" :footer="null" :centered="true" :closable="false" :destroyOnClose="true"
      :width="parentWidth >= 900 ? 1000 : '70%'" :maskStyle="{ 'background-color': 'rgba(0,0,0,.6' }"
      @cancel="onVideoClose" class="video-player-model">
      <iframe class="video-player vjs-custom-skin iframeRWD" :class="{ 'iframeVideo': parentWidth < 900 }"
        :src="linkHotspotSrc" frameborder="0" width="100%" height="400"></iframe>
    </a-modal>
    <a-modal class="textModal" :width="700" v-model="pictextHotspotVisible" :title="pictextHotspotTitle" :footer="null"
      :centered="true">
      <div v-html="pictextHotspotContent" class="ql-editor" :style="{ height: winFullHeight * 0.7 + 'px' }"></div>
    </a-modal>
    <a-modal v-model="videoHotspotVisible" :footer="null" :centered="true" :closable="false" :destroyOnClose="true"
      :width="parentWidth >= 900 ? 1000 : '70%'" :maskStyle="{ 'background-color': 'rgba(0,0,0,.6)' }"
      @cancel="onVideoClose" class="video-player-model">
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :options="videoHotspotPlayerOptions"
        :playsinline="true" customEventName="customstatechangedeventname"></video-player>
    </a-modal>

    <audio ref="guideAudioPlayer" :src="guideMusicSrc" preload="none" autoplay v-show="false"></audio>
    <a-modal :visible="!loadingState && passwordVisible" :closable="false" :footer="null"
      :title="$t('tour.viewPwd.title')" style="top: 100px">
      <a-row>
        <a-col :span="12" :offset="6">
          <a-input :placeholder="$t('tour.viewPwd.placeholder')" v-model="inputViewPassword" />
          <a-button style="margin-top: 20px" type="primary" block @click="checkViewPassword">{{
            $t("actionTitles.ascertain") }}</a-button>
        </a-col>
      </a-row>
    </a-modal>

    <!--說一說-->
    <div class="comment-modal" v-if="commentVisible">
      <div class="comment-title">
        <img src="../../static/images//message.png" />
        <span>{{ $t("tour.msg.title") }}</span>
      </div>
      <div class="comment-body">
        <a-textarea :placeholder="$t('tour.msg.placeholder')" v-model="comment" :auto-size="{ minRows: 3, maxRows: 3 }"
          @click="lineLogin($event)" @keyup="syncKrpanoComment" />
      </div>
      <div class="comment-footer">
        <div class="footer-left" @click="onClickHide">
          <div class="option">
            <img src="../../static/images/hide.png" />
            <span>{{ $t("tour.hide") }}</span>
          </div>
        </div>
        <div class="footer-right">
          <a-button type="primary" class="fb-btns" @click="publishComment">{{
            $t("actionTitles.publish")
          }}</a-button>
          <a-button class="cancel-btns" @click="onCancel">{{
            $t("actionTitles.cancel")
          }}</a-button>
        </div>
      </div>
    </div>
    <!--分享-->
    <a-modal class="shareModal" centered v-model="shareVisible" :title="$t('tour.workQR')" :width="500" :footer="null"
      :destroyOnClose="true" @ok="() => (this.shareVisible = false)">
      <Share :isOnlyQr="true" :workId="newWork.base.id"></Share>
    </a-modal>
    <div v-show="loadingState" id="loading">
      <img src="../../static/images/loading.png" />
    </div>
    <div class="vr-show-cover" v-if="showCover"></div>
    <div class="thing-base-box" v-if="!showBaseBtnByMobile && (newWork.base.thing_no != '')">
      <div class="thing-name-box">
        <div class="name-box">
          {{ newWork.base.thing_base.object_name + '(' + newWork.base.thing_no + ')' }}
        </div>
        <div class="base-title" @click="showThingBase"
          :style="newWork.base.store_type == 1 ? 'background-color:#920783;' : 'background-color:#22b24c;'">
          基本資料 >
        </div>
      </div>
    </div>
    <div class="thing-base-panel" v-show="isShowThingBase" v-if="(newWork.base.thing_no != '')">
      <div class="panel-header">
        <div class="header-base-title">基本資料</div>
        <div class="look-more">
          <div style="cursor: pointer" @click="goToMore">看更多 ></div>
          <div style="margin-left:20px;cursor: pointer" @click="closeThingBase">X</div>
        </div>
      </div>
      <div class="line-header"></div>
      <div class="panel-body">
        <div class="base-box">
          <div class="base-item">
            <div class="item-title">總價</div>
            <div class="item-value">{{ newWork.base.thing_base.object_price == '' ? '--' :
              newWork.base.thing_base.object_price + '萬' }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">地址</div>
            <div class="item-value" :style="showBaseBtnByMobile ? 'width: 50px;' : ''">{{
              newWork.base.thing_base.object_addr
              == '' ? '--' : newWork.base.thing_base.object_addr }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">地坪</div>
            <div class="item-value">{{ newWork.base.thing_base.land_size == '' ? '--' :
              newWork.base.thing_base.land_size + '坪' }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">格局</div>
            <div class="item-value">{{ newWork.base.thing_base.object_pattern == '' ? '--' :
              newWork.base.thing_base.object_pattern }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">樓層</div>
            <div class="item-value">{{ newWork.base.thing_base.object_layer == '' ? '--' :
              newWork.base.thing_base.object_layer }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">警衛管理</div>
            <div class="item-value">{{ newWork.base.thing_base.manage == '' ? '--' : newWork.base.thing_base.manage }}
            </div>
          </div>
        </div>
        <div class="base-box">
          <div class="base-item">
            <div class="item-title">單價</div>
            <div class="item-value" :style="showBaseBtnByMobile ? 'width: 50px;' : ''">{{
              newWork.base.thing_base.single_price == '' ? '--' : newWork.base.thing_base.single_price }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">建坪</div>
            <div class="item-value">{{ newWork.base.thing_base.object_size == '' ? '--' :
              newWork.base.thing_base.object_size + '坪' }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">屋齡</div>
            <div class="item-value">{{ newWork.base.thing_base.object_age == '' ? '--' :
              newWork.base.thing_base.object_age }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">房屋類型</div>
            <div class="item-value">{{ newWork.base.thing_base.object_type == '' ? '--' :
              newWork.base.thing_base.object_type }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">車位</div>
            <div class="item-value" :style="showBaseBtnByMobile ? 'width: 50px;' : ''">{{
              newWork.base.thing_base.object_parking == '' ? '--' : newWork.base.thing_base.object_parking }}</div>
          </div>
          <div class="base-item">
            <div class="item-title">管理费</div>
            <div class="item-value" :style="showBaseBtnByMobile ? 'width: 50px;' : ''">{{
              newWork.base.thing_base.securityfee
              == '' ? '--' : newWork.base.thing_base.securityfee }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qwhouseLogo from '../../static/images/qwhouseLogo.png'
import screenfull from "screenfull";
import Share from "../Share";
import { mapGetters, mapState } from "vuex";
import ThumbSwiper from "./ThumbSwiper";
import ImageDrawer from "../ImageDrawer";
import FullSandbox from "./FullSandbox";
import WordViewer from "./WordViewer";
import MarqueeBox from "./MarqueeBox";
import aiAnchor from "../aiAnchor/Index.vue";
import VRMixin from "../../mixins/VRMixin.js";
import { isMobile } from "../../static/js/utils/tools.js";

let wx = {};
if (process.client) {
  wx = require("weixin-js-sdk");
}

export default {
  props: {
    offLine: {  //是否是離線組件，離線情況下，所有ajax接口都不引用
      type: Boolean,
      default: false,
    },
    newWork: {
      type: Object,
      default: {},
    },
    isVrTalk: {
      type: Boolean,
      default: false,
    },
    vrController: {
      type: Boolean,
      default: false,
    },
    socket: {
      type: Object,
      default: () => (undefined),
    },
    userRoomId: {
      type: String,
      default: "",
    }
  },
  // mixins: [VRMixin],
  components: {
    Share,
    ThumbSwiper,
    ImageDrawer,
    FullSandbox,
    WordViewer,
    MarqueeBox,
    aiAnchor
  },
  data() {
    return {
      activePano: "pano",
      panoBoxStyle: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        zIndex: -1,
      },
      panoStyle: {
        width: "100%",
        height: "100%",
      },
      pano2Style: {
        display: "none",
        width: "50%",
        height: "100%",
      },
      tongPingState:false,
      qwhouseLogo,
      passwordVisible: false,
      isShowSplash: false,
      cover: "",
      pano3dVisible: false,
      isPano3d: false,
      btnsVisible: true,
      outSandShow: true, //沙盤之外的圖標，當放大沙盤時，除了沙盤其他button都要隱藏
      fullscreenVisible: false,
      // isBtnMenu: false,
      isFullscreen: false,
      tourGuideVisible: true,
      radarVisible: true,
      webvrVisible: false,
      musicVisible: false,
      speechVisible: false,
      gyroVisible: false,
      isSandSceneVisible: false,
      spTop: "",
      fullImgVisible: false,

      showthumbsState: false,
      tourGuideState: 0,
      musicState: true,
      speechState: true,
      gyroState: false,

      rotateState: true,

      hotspotVoiceState: false,
      voiceHotspotId: "",
      images: [],
      linkHotspotVisible: false,
      linkHotspotSrc: "",

      pictextHotspotVisible: false,
      pictextHotspotTitle: "",
      pictextHotspotContent: "",

      wordHotspotVisible: false,
      wordHotspotTitle: "",
      wordHotspotContent: "",

      videoHotspotVisible: false,
      parentWidth: 0,
      videoHotspotPlayerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,瀏覽器準備好時開始回放。
        muted: false, // 默認情況下將會消除任何音頻。
        loop: false, // 導致視頻一結束就重新開始。
        preload: "auto", // 建議瀏覽器在<video>加載元素後是否應該開始下載視頻數據。auto瀏覽器選擇最佳行為,立即開始加載視頻（如果瀏覽器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 將播放器置於流暢模式，並在計算播放器的動態大小時使用該值。值應該代表一個比例 - 用冒號分隔的兩個數字（例如"16:9"或"4:3"）
        fluid: true, // 當true時，Video.js player將擁有流體大小。換句話說，它將按比例縮放以適應其容器。
        sources: [
          {
            type: "", //這裡的種類支持很多種：基本視頻格式、直播、流媒體等，具體可以參看git網址項目
            src: "", //url地址
          },
        ],
        notSupportedMessage: this.$t("tour.message.videoMsg"), //允許覆蓋Video.js無法播放媒體源時顯示的默認信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按鈕
        },
        width: '1000px',
        height: '700px',
      },

      guideMusicSrc: "",
      guideAudioState: 0,
      inputViewPassword: "",
      commentVisible: false,
      comment: "",
      shareVisible: false,
      //傳遞給縮略圖組件的數據
      group_List: [],
      //krpano對象，通過該對像調用krpano原生方法
      krpanoObj: null,
      loadingState: true,
      isSandFull: false,
      firstLoad: true,
      //free 增加的部分
      winFullHeight: 0,
      isMarqueeVivsble: false,
      isOverdue: false,
      sceneShow: true,
      isInitFinished: false,
      timer: null,
      title: "",
      wxcomment_list: [],
      // line登錄
      clientId: "",
      redirect_uri: '',
      vrtalkH: 50,
      initEventqueue: [],
      isShowThingBase: false,
      showBaseBtnByMobile: false,
      tongPingIsShow: false,
      userInfo: [],
      sandTableHeight: 900,
      aiAnchorHeight: 500,
    };
  },
  computed: {
    ...mapState({
      siteInfo: (state) => state.siteConfig.siteInfo,
    }),
    ...mapState({
      siteInfo: (state) => state.siteConfig.siteInfo,
    }),
    ...mapGetters([
      "vrbase",
      "currentScenesId",
      "editSandtable",
      "currentHlookat",
      "wxUserInfo",
    ]),
    actionBtnH() {
      let h = this.isMarqueeVivsble ? 40 : 10;
      if (this.isVrTalk) {
        h += this.vrtalkH
      }
      return h + 'px'
    },
    showCover() {
      return this.isVrTalk && !this.vrController;
    }
  },
  watch: {
    isInitFinished(newVal, oldVal) {
      if (newVal && !oldVal) {
        for (let i = 0; i < this.initEventqueue.length; i++) {
          this.setNoticeData(this.initEventqueue[i]);
        }
        this.initEventqueue = [];
      }
    },
    pictextHotspotVisible(newVal, oldVal) {
      if (newVal === false) {
        if (this.isVrTalk && this.vrController) {
          this.socketSendMessage({ cmd: 100012, data: { state: "close" } });
        }
      }
    },
    wordHotspotVisible(newVal, oldVal) {
      if (newVal === false) {
        if (this.isVrTalk && this.vrController) {
          this.socketSendMessage({ cmd: 100013, data: { state: "close" } });
        }
      }
    },
    videoHotspotVisible(newVal, oldVal) {
      if (newVal === false) {
        if (this.isVrTalk && this.vrController) {
          this.socketSendMessage({ cmd: 100014, data: { state: "close" } });
        }
      }
    }
  },
  methods: {
    menuTop() {
      //設置選單欄的top
      if (isMobile()) {
        return "auto";
      }
      if (!isMobile() && this.isMarqueeVivsble) {
        return "44px";
      }
      if (!isMobile() && !this.isMarqueeVivsble) {
        return "14px";
      }
    },
    setWidth() {
      //設置選單欄中的span的寬度
      if (this.newWork.menus.length == 1) {
        return "100%";
      }
      if (this.newWork.menus.length == 2) {
        return "50%";
      }
      if (this.newWork.menus.length == 3) {
        return "33.33%";
      }
      if (this.newWork.menus.length == 4) {
        return "25%";
      }
      if (this.newWork.menus.length >= 5) {
        return "20%";
      }
    },
    handleSandboxShow(secneId = this.currentScenesId) {
      // console.log(
      //   "沙盤====",
      //   this.editSandtable,
      //   this.currentScenesId,
      //   this.editSandtable.scenes[secneId]
      // );
      this.$store.commit("SELECT_SCENES", secneId);
      if (this.editSandtable.scenes[secneId]) {
        this.radarVisible = true;
        this.isSandSceneVisible = true;
        this.closeFullImage();
      } else {
        this.radarVisible = false;
        this.isSandSceneVisible = false;
      }
    },
    showShareQr() {
      this.shareVisible = true;
    },
    show_comment() {
      this.commentVisible = true;
      if (this.wxUserInfo) {
        wxTourComment.init(this.krpanoObj, this.wxUserInfo.headimgurl);
        wxTourComment.show_comment();
      }
      wxTourComment.switch_show_comments(true, this.wxcomment_list);
    },
    syncKrpanoComment() {
      wxTourComment.sync_comment_content(this.comment);
    },
    // 微信line登錄
    wxLogin(event) {
      if (!this.wxUserInfo && process.client) {
        let redirectUrl = location.href;
        let scope =
          window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
            "micromessenger"
            ? "snsapi_userinfo"
            : "snsapi_login";
        this.$axios
          .get("/wechat/getOauthRedirect", {
            params: {
              redirect_url: redirectUrl,
              state: "",
              scope: scope,
            },
          })
          .then((res) => {
            location.href = res.data;
          });
      } else {
        event.currentTarget.placeholder =
          "拖動頭像就可以發表說一說到指定位置哦";
        wxTourComment.init(this.krpanoObj, this.wxUserInfo.headimgurl);
        wxTourComment.show_comment();
      }
    },
    lineAppid() {
      //獲取appid（寫在wxLogin裡面，接口返回數據會比較慢）
      this.$axios.post("/lineAppid").then((res) => {
        this.clientId = res.data.appid;
        this.redirect_uri = res.data.redirect_uri;
      })
    },
    lineLogin(event) {
      if (!this.wxUserInfo && process.client) {
        let lineUrl = "https://access.line.me/oauth2/v2.1/authorize";
        lineUrl += "?response_type=code";
        lineUrl += "&client_id=" + this.clientId;
        lineUrl += "&redirect_uri=" + this.redirect_uri;
        lineUrl += "&state=" + this.$route.path;
        lineUrl += "&scope=profile%20openid%20phone";
        location.href = lineUrl
      } else {
        event.currentTarget.placeholder =
          "拖動頭像就可以發表說一說到指定位置哦";
        wxTourComment.init(this.krpanoObj, this.wxUserInfo.headimgurl);
        wxTourComment.show_comment();
      }
    },
    //如果有傳遞lineCode,且不是行銷庫進入時,則請求line接口
    lineLoginInit() {
      let _this = this;
      let lineCode = this.$route.query.lineCode;
      if (!this.isVrTalk && lineCode && this.wxUserInfo == undefined) {
        this.$axios.post("/line/login", { code: lineCode, type: 2, param_id: this.newWork.base.id })
          .then((res) => {
            if (res.code == 1 && res.data) {
              let linedata = {
                nickname: res.data.displayName,
                id: res.data.customer_id,
                headimgurl: res.data.pictureUrl + "/large"
              };
              _this.$store.commit("SET_WX_USER_INFO", linedata);
            }
          })
          .catch((err) => {
            console.log("line登錄失敗", err);
          });
      }
    },
    onCancel() {
      this.comment = "";
      this.commentVisible = false;
      wxTourComment.init(this.krpanoObj);
      wxTourComment.cancel_comment();
    },
    publishComment() {
      let _this = this;
      if (this.comment == "") {
        return false;
      }
      let commentRes = wxTourComment.get_comment();
      let dommentData = {
        wid: this.newWork.base.id,
        scene_id: commentRes.scene_id,
        content: this.comment,
        head_img: this.wxUserInfo.headimgurl,
        ath: commentRes.ath,
        atv: commentRes.atv,
        nickname: this.wxUserInfo.nickname,
        sex: this.wxUserInfo.sex,
        province: this.wxUserInfo.province,
        city: this.wxUserInfo.city,
        customer_id: this.wxUserInfo.id,
      };
      this.$axios
        .get("/wxcomment/add", {
          params: dommentData,
        })
        .then((res) => {
          if (res.code == 1) {
            this.show_comment_list();
            _this.onCancel();
          }
        });
    },
    //顯示評論（某個場景的）
    show_comment_list() {
      let scene_id = this.krpanoObj.get("xml.scene");
      this.$axios
        .get("/wxcomment/list", {
          params: { scene_id: scene_id },
        })
        .then((res) => {
          if (res.code == 1 && res.data.length > 0) {
            this.wxcomment_list = res.data;
            wxTourComment.show_comment_scene(this.wxcomment_list);
          }
        });
    },
    onClickSwitch() { },
    onClickHide() {
      wxTourComment.switch_show_comments(false, this.wxcomment_list);
      this.onCancel();
    },
    toggleBtns(visible) {
      if (visible == undefined) {
        this.btnsVisible = !visible;
      } else {
        this.btnsVisible = visible;
      }
      //this.toggleShowthumbs(this.btnsVisible);
    },
    // 沙盤的放大和縮小
    sandTableZoomIn(isZoomIn, ratio) {
      if (isZoomIn) {
        this.isSandSceneVisible = false;
        this.isSandFull = true;
      } else {
        this.isSandFull = false;
        this.isSandSceneVisible = true;
      }

      //其他
      this.toggleoutSandShow(!isZoomIn);
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 100010, isZoomIn });
      }
    },
    closeFullImage() {
      this.isSandFull = false;
      this.isSandSceneVisible = true;
      this.toggleoutSandShow(true);
    },
    toggleoutSandShow(visible) {
      if (visible == undefined) {
        this.outSandShow = !visible;
      } else {
        this.outSandShow = visible;
      }
    },
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      screenfull.toggle();
    },
    toggleFullscreenVisible(visible) {
      if (visible == undefined) {
        this.fullscreenVisible = !visible;
      } else {
        this.fullscreenVisible = visible;
      }
    },
    toggleWebvrVisible(visible) {
      if (visible == undefined) {
        this.webvrVisible = !visible;
      } else {
        this.webvrVisible = visible;
      }
    },
    toggleMusicVisible(visible) {
      if (visible == undefined) {
        this.musicVisible = !visible;
      } else {
        this.musicVisible = visible;
      }
    },
    toggleSpeechVisible(visible) {
      if (visible == undefined) {
        this.speechVisible = !visible;
      } else {
        this.speechVisible = visible;
      }
    },
    toggleGyroVisible(visible) {
      if (visible == undefined) {
        this.gyroVisible = !visible;
      } else {
        this.gyroVisible = visible;
      }
    },
    toggleShowthumbs(state) {
      if (this.isVrTalk && !this.vrController) return; // 被帶看者不顯示場景選擇
      //注意，state未傳時部分瀏覽器不是undefined，而是對像{"isTrusted":true}
      if (state != true && state != false) {
        this.showthumbsState = !this.showthumbsState;
      } else {
        this.showthumbsState = state;
      }
      this.$nextTick(() => {
        this.$refs.thumbList && (this.$refs.thumbList.showThumbs = this.showthumbsState);
      });
      // console.log('this.showthumbsState',this.showthumbsState)
      // console.log('this.$refs.thumbList',this.$refs.thumbList)
      // console.log('this.$refs.thumbList.showThumbs',this.$refs.thumbList.showThumbs)
      // console.log('this.showthumbsState',this.showthumbsState)
    },
    showTourGuideBtn() {
      this.tourGuideVisible = true;
    },
    hideTourGuideBtn() {
      this.tourGuideVisible = false;
    },
    showRadarBtn() {
      this.radarVisible = true;
      this.isSandSceneVisible = true;
    },
    hideRadarBtn() {
      this.radarVisible = false;
      this.isSandSceneVisible = false;
    },
    startTourGuide() {
      this.$emit('show-vr-guide');
      this.tourGuideState = 1;
      this.toggleBtns(false);
      startTourGuide();
    },
    pauseTourGuide() {
      this.tourGuideState = 2;
      pauseTourGuide();
    },
    resumeTourGuide() {
      this.tourGuideState = 1;
      resumeTourGuide();
    },
    stopTourGuide() {
      this.$emit('show-vr-guide');
      this.tourGuideState = 0;
      this.toggleBtns(true);
      stopTourGuide();
    },
    showWebVR() {
      this.showPano3d(false);
      showWebVR();
    },
    toggleMusicBtnState(state) {
      if (state == undefined) {
        this.musicState = !state;
      } else {
        this.musicState = state;
      }
    },
    toggleSpeechBtnState(state) {
      if (state == undefined) {
        this.speechState = !state;
      } else {
        this.speechState = state;
      }
    },
    toggleMusic(state) {
      this.toggleMusicBtnState(state);
      krToggleMusic(this.musicState);
      // 如果是vr帶看，且角色為主持人=》發送更新通知
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 4, data: this.musicState });
      }
    },
    toggleSpeech(state) {
      this.toggleSpeechBtnState(state);
      krToggleSpeech(this.speechState);
      // 如果是vr帶看，且角色為主持人=》發送更新通知
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 12, data: this.speechState });
      }
    },
    toggleGyro(state) {
      if (state == undefined) {
        this.gyroState = !state;
      } else {
        this.gyroState = state;
      }
      toggleGyro(this.gyroState);
    },
    toggleRotate(state) {
      this.rotateState = state;
      if (state) {
        this.krpanoObj.call("set(autorotate.speed, 10.0)");
      }
      else {
        //this.krpanoObj.call("set(autorotate.speed, 0)");
        this.krpanoObj.call("autorotate.stop();set(autorotate.speed, 0);");
      }
    },
    toggleKrpSandTable() {
      // toggleKrpSandTable();
      this.isSandSceneVisible = !this.isSandSceneVisible;
      /*if (this.isSandSceneVisible) {
        this.isBtnMenu = false;
      }*/
      // 帶看的時候同步沙盤的開關
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 3, data: this.isSandSceneVisible ? 1 : 0 });
      }
    },
    sceneInit() {
      if (this.tourGuideState != 1 && !getWebvrOpen()) {
        this.toggleBtns(true);
      }
    },
    showImgHotspot(sceneId, hotspotId) {
      this.images = this.newWork.scenes[sceneId].hotspot[hotspotId].content.map(
        (p) => {
          return p.url;
        }
      );
      //const viewer = this.$el.querySelector(".hotspot-images").$viewer;
      //viewer.show();
      newPhotoSwipe(this.images);
      this.toggleShowthumbs(false);
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 100011, data: { state: "open", sceneId: sceneId, hotspotId: hotspotId } });
      }
    },
    onCloseImgHotspot() {
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 100011, data: { state: "close" } });
      }
    },
    openHotspotLink(link, blank) {
      //判斷是否是uniapp
      if (link.indexOf("uni://") == 0) {
        let uniIndexArr = link.split("uni://");
        let uniAppParam = uniIndexArr[1].replace(/\s*/g, "");
        let param = uniAppParam.split("&");
        let postData = "{";
        for (let i = 0; i < param.length; i++) {
          let paramName = param[i].split("=")[0];
          let paramValue = param[i].split("=")[1];
          if (
            paramName != undefined &&
            paramName != null &&
            paramName != "" &&
            paramValue != undefined &&
            paramValue != null &&
            paramValue != ""
          ) {
            postData += '"' + paramName + '":' + '"' + paramValue + '",';
          }
        }

        postData = postData.substring(0, postData.lastIndexOf(","));
        postData += "}";
        postData = JSON.parse(postData);
        // console.log("uniapp");
        // console.log(postData);
        uni.postMessage({
          data: postData,
        });
      } else if (link.indexOf("mini:") == 0) {
        var ua = window.navigator.userAgent.toLowerCase();
        var url = link.split("mini:");
        //先判斷是否微信瀏覽器
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //再判斷一下是否在小程序裡
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              //要跳轉的小程序路由，跟原生小程序一模一樣
              wx.miniProgram.navigateTo({
                url: url[1]
                //fail:()=>{wx.miniProgram.switchTab({url:url[1]})}
              })
              wx.miniProgram.switchTab({
                url: url[1]
              })
            }
          });
        }
      } else {
        //彈框
        /*if (alert == "1") {
          this.linkHotspotSrc = link;
          this.linkHotspotVisible = true;
        } else {
          var target = blank == "1" ? "_blank" : "_self";
          window.open(link, target);
        }*/
        if (blank == 2) {
          window.open(link, '_self')
        } else if (blank == 3) {
          this.linkHotspotSrc = link;
          this.linkHotspotVisible = true;
        } else {
          window.open(link, '_blank')
        }
      }
    },
    showPictextHotspot(title, content) {
      this.pictextHotspotVisible = true;
      this.pictextHotspotTitle = title;
      this.pictextHotspotContent = imgtext_decode(content);
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 100012, data: { state: "open", title: title, content: content } });
      }
    },
    showWordHotspot(title, content) {
      this.wordHotspotVisible = true;
      this.wordHotspotTitle = title;
      this.wordHotspotContent = content;
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 100013, data: { state: "open", title: title, content: content } });
      }
    },
    closeWordHotspot() {
      this.wordHotspotVisible = false;
    },
    showVideoHotspot(url, is_auto_play) {
      // console.log("showVideoHotspot===>", is_auto_play > 0)
      this.videoHotspotPlayerOptions.sources = [{ src: url }];
      this.videoHotspotPlayerOptions.autoplay = is_auto_play > 0;
      this.videoHotspotVisible = true;
      this.$nextTick(() => {
        this.toggleSpeech(false);
        this.toggleMusic(false);
      });
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 100014, data: { state: "open", url: url } });
      }
    },
    onVideoClose() {
      this.toggleMusic(true);
    },
    handleAfterCloseVideoHotspot() {
      this.toggleMusic(true);
    },
    playGuideAudio(url) {
      this.guideMusicSrc = url;
      this.$refs.guideAudioPlayer.play();
    },
    stopGuideAudio() {
      this.$refs.guideAudioPlayer.pause();
      this.guideMusicSrc = "";
    },
    pauseGuideAudio() {
      this.$refs.guideAudioPlayer.pause();
    },
    resumeGuideAudio() {
      this.$refs.guideAudioPlayer.play();
    },
    hlookatChange(sceneId, hlookat) {
      if (this.currentHlookat != hlookat) {
        this.$store.dispatch("setCurrentHlookat", hlookat);
      }
      //只有帶看瀏覽且為主持人時才監聽操作
      if (
        this.isVrTalk &&
        this.vrController &&
        this.isInitFinished
      ) {
        if (!this.timer) {
          this.timer = setTimeout(() => {
            const { vlookat, hlookat, fov } = getSceneViewParams();
            this.socketSendMessage({ cmd: 1, data: { vlookat, hlookat, fov } });
            clearTimeout(this.timer);
            this.timer = null;
          }, 50);
        }
      }
    },
    showPano3d(visible) {
      removepano("krpanoSWFObject3d");

      if (this.isVrTalk && !this.vrController) return; // 被帶看者不顯示

      if (visible != true && visible != false) {
        this.pano3dVisible = !this.pano3dVisible;
      } else {
        this.pano3dVisible = visible;
      }

      if (this.pano3dVisible) {
        console.log('in showPano3d', visible);
        this.$nextTick(() => {
        this.pano3dInit();
        });
      }
    },
    pano3dInit() {
      const pano3dElement = document.getElementById("pano3d");
      if (!pano3dElement) {
        console.error("error pano3d");
        return;
      }
      removepano("krpanoSWFObject3d");
      // 3D模型屋重新加載
      embedpano({
        xml: `/api/tourXml3D?uuid=${this.newWork.base.uuid}`,
        target: "pano3d",
        id: "krpanoSWFObject3d",
        bgcolor: "#b1b1b1",
        html5: "webgl+only",
        mobilescale: 0.7,
        consolelog: true,
        // passQueryParameters: true,
      });
    },
    checkPanoElement() {
      // 建立觀察者，偵測到變動則會執行裡面的任務
        const observer = new MutationObserver((mutations, observer) => {
          const panoElement = document.getElementById('pano');
          if (panoElement) {
            observer.disconnect(); //註銷已被觀察的DOM元素
            this.initializeKrpano();
          }
        });
        const target = document.body; //指定檢查body
        const options = { childList: true, subtree: true }; //檢查直屬子節點和所有子節點變動
        //透過observe來觀察這個observer函式來指定被觀察的對象
        observer.observe(target, options);
      },

    initializeKrpano() {
      let krsettings = {
        "events[skin_events].onpreviewcomplete": "js(tourHideLoading());", //隱藏加載中狀態
        "events[init_view_event].onclick": "js(tourHideThumbs());", //點擊漫遊隱藏縮略圖
        "events[skin_events].onnewscene": "js(tourUpdateCurrentScene());", //進入場景時更新當前場景值給縮略圖組件
        //"events[skin_events].onloadcomplete": "delayedcall(3, js(show_comment_list()));", //場景加載完成獲取當前場景的所有評論
        "autorotate.enabled": !this.isVrTalk,
        //"autorotate.horizon'] = work.sets.keepview=='1' ? "off" : "0.0";
        "skin_settings.start_animation": this.newWork.sets.start_animation,
      };
      //關閉自動旋轉
      if (this.newWork.sets.auto_rotate == 1) {
        krsettings["autorotate.speed"] = "0";
        this.rotateState = false;
      }
      this.krpanoObj = this.offLine
        ? launchKrpano(krsettings, "/ssr/static/tour/tour.swf")
        : launchKrpano(krsettings);
    },
    workInit() {
      if (this.newWork.base.id != undefined) {
        // 判斷用戶賬號是否過期
        if (this.newWork.base && this.newWork.base.expire_status) {
          this.isOverdue = true;
        }
        //展示開場封面
        if (!isMobile() && this.newWork.ads.cover.pc) {
          this.cover = this.newWork.ads.cover.pc;
        } else if (isMobile() && this.newWork.ads.cover.mob) {
          this.cover = this.newWork.ads.cover.mob;
        }
        if (this.cover != "") {
          this.isShowSplash = true;
        }
        // document.title = this.newWork.base.name;

        this.wxInit();
        initVrshowVue(this);
        setWork(this.newWork);
        setMode("tour");
        let scene_id = this.$route.query.scene
          ? this.$route.query.scene
          : "";
        if (process.env.VUE_APP_ENV == "offline") {
          setTourXml(`/tour.xml`);
        } else {
          console.log('not offline');
          setTourXml(
            `/api/tourXml?uuid=${this.newWork.base.uuid}&scene_id=${scene_id}`
          );

        }
        this.checkPanoElement();
        this.group_List = this.getGroupList(
          this.newWork.scene_group.groups,
          this.newWork.scenes
        );
        let scenesCount = Object.keys(this.newWork.scenes).length;
        if (scenesCount > 1) {
          this.sceneShow = true;
        } else {
          this.sceneShow = false;
        }
        // console.log("場景初始化", this.group_List);
        this.getFirstSenceFromAll();
        this.handleSandboxShow();
        this.$store.dispatch("setVRBase", this.newWork).then(() => {
          this.getFirstSenceFromAll();
          this.handleSandboxShow();
        });

        // 3D模型屋

        if (this.newWork.base.type == 3) {
          this.isPano3d = true;
        }

      }
      this.$message.destroy();
    },
    async InitAi() {
      if (process.client) {
        const showcase = document.getElementById('__nuxt')
        if (window.initIosPaly) window.initIosPaly(showcase)
      }
    },
    wxInit() {
      if (this.offLine) {
        return;
      }
      let self = this;
      this.$axios
        .get("/wechat/getJsSign", {
          params: { url: location.href.split("#")[0] },
        })
        .then((res) => {
          wx.config({ ...res.data });
          wx.ready(function () {
            //需在用戶可能點擊分享按鈕前就先調用
            wx.updateAppMessageShareData({
              title: self.newWork.base.name, // 分享標題
              desc: self.newWork.base.brief_share, // 分享描述
              link: location.href.split("#")[0], // 分享鏈接，該鏈接域名或路徑必須與當前頁面對應的公眾號JS安全域名一致
              imgUrl: self.newWork.base.thumb_path, // 分享圖標
              success: function () {
                // 設置成功
              },
            });
            wx.updateTimelineShareData({
              title: self.newWork.base.name, // 分享標題
              link: location.href.split("#")[0], // 分享鏈接，該鏈接域名或路徑必須與當前頁面對應的公眾號JS安全域名一致
              imgUrl: self.newWork.base.thumb_path, // 分享圖標
              success: function () {
                // 設置成功
              },
            });
          });
        });
    },
    hideLoding() {
      document.getElementById("#lading").remove();
    },
    sceneChange(currentSenceId) {
      this.isInitFinished = true;
      this.$store.dispatch("setCurrentScnId", currentSenceId);
      this.handleSandboxShow(currentSenceId);

      //只有帶看瀏覽且為主持人時才監聽操作
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 2, data: currentSenceId });
      }
      krToggleHotspotVoice(false);
      // 場景改變，更換背景音樂設置
      this.handleBgm(currentSenceId);
      // 場景改變，更換解說設置
      this.handleBgv(currentSenceId);
      // 場景改變，更換補天補地設置
      this.handleShade(currentSenceId);
      // 場景改變，更換特效設置
      this.updateSpecialEffects(currentSenceId);

      if (!this.isVrTalk) {
        let tongPingData = this.newWork.scenes[currentSenceId].tongping;
        if (tongPingData && Object.keys(tongPingData).length > 1) {
          this.tongPingIsShow = true;
        } else {
          this.tongPingIsShow = false;
        }
      }
    },
    updateSpecialEffects(sceneId) {

      if (this.vrbase.scenes[sceneId].special_effects && this.vrbase.scenes[sceneId].special_effects.special_type && this.vrbase.scenes[sceneId].special_effects.is_display) {
        const sceneEffects = this.vrbase.scenes[sceneId].special_effects;
        // console.log("currentEffects=0=", sceneEffects, this.effects_is_flobal)
        setSpecialEffects(sceneEffects);
      } else if (this.vrbase.special_effects && this.vrbase.special_effects.special_type && this.vrbase.special_effects.is_display) {
        const currentEffects = this.vrbase.special_effects;
        // console.log("currentEffects=1=", currentEffects, this.effects_is_flobal)
        setSpecialEffects(currentEffects);
      }
    },
    handleBgm(sceneId) {
      const hidebgm = this.vrbase.sets.hidebgm;
      this.toggleMusicVisible(!hidebgm);
      if (hidebgm) return;
      if (this.vrbase.scenes[sceneId].bg_music && this.vrbase.scenes[sceneId].bg_music.bgm) {
        const sceneBgm = this.vrbase.scenes[sceneId].bg_music.bgm;
        krpanoHandleBgmAndBgv(true, sceneBgm, this.musicState);
      } else if (this.vrbase.ads.bgm) {
        const globalBgm = this.vrbase.ads.bgm;
        krpanoHandleBgmAndBgv(true, globalBgm, this.musicState);
      } else {
        //沒有音樂，關閉音樂並隱藏開關
        // console.log("krToggleMusic close")
        krToggleMusic(false);
        this.toggleMusicVisible(false);
      }
    },
    handleBgv(sceneId) {
      const hidebgv = this.vrbase.sets.hidebgv;
      this.toggleSpeechVisible(!hidebgv);
      if (hidebgv) return;
      if (this.vrbase.scenes[sceneId].speech_explain && this.vrbase.scenes[sceneId].speech_explain.url) {
        const sceneBgv = this.vrbase.scenes[sceneId].speech_explain.url;
        krpanoHandleBgmAndBgv(false, sceneBgv, this.speechState);
      } else if (this.vrbase.ads.speech_explain) {
        const globalBgv = this.vrbase.ads.speech_explain;
        krpanoHandleBgmAndBgv(false, globalBgv, this.speechState);
      } else {
        //沒有解說，關閉解說並隱藏開關
        // console.log("krToggleSpeech close")
        krToggleSpeech(false);
        this.toggleSpeechVisible(false);
      }
    },
    handleShade(sceneId) {
      //先移除
      const skyMaskId = "shade_sky_mask_id";
      const groundMaskId = "shade_ground_mask_id";
      let date = new Date();
      let currentDateParam = "?v=" + date.getFullYear() + "" + (date.getMonth() + 1) + "" + date.getDate();
      removeAllShade(skyMaskId, groundMaskId);
      //global
      const mask_global_settings = this.vrbase.ads.fix_logo;
      //sceene
      const mask_scene_settings = this.vrbase.scenes[sceneId].sky_land_shade;
      if (mask_scene_settings && mask_scene_settings.land) {
        addSceneShade(groundMaskId, mask_scene_settings.land + currentDateParam, 90, 1, 0)
      } else if (mask_global_settings && mask_global_settings.land) {
        addSceneShade(groundMaskId, mask_global_settings.land + currentDateParam, 90, mask_global_settings.land_scale, mask_global_settings.land_angle)
      }

      if (mask_scene_settings && mask_scene_settings.sky) {
        addSceneShade(skyMaskId, mask_scene_settings.sky + currentDateParam, -90, 1, 0)
      } else if (mask_global_settings && mask_global_settings.sky) {
        addSceneShade(skyMaskId, mask_global_settings.sky + currentDateParam, -90, mask_global_settings.sky_scale, mask_global_settings.sky_angle)
      }
    },

    // 獲取全部場景的第一個場景、
    getFirstSenceFromAll() {
      console.log('觸發getFirstSenceFromAll');
      const scenesArr = Object.keys(this.newWork.scenes);
      const currId =
        scenesArr.length > 0
          ? this.newWork.scenes[scenesArr[0]]["scene_id"]
          : "";
      this.$store.dispatch("setCurrentScnId", currId);
    },
    showProfile() {
      this.showPictextHotspot(
        this.$t("descriptions.briefInfo"),
        this.newWork.base.brief
      );
    },
    checkViewPassword() {
      if (this.inputViewPassword == this.newWork.sets.view_passwd) {
        this.passwordVisible = false;
        this.toggleShowthumbs(true);
      } else {
        this.$message.error(this.$t("message.wrongPwd"));
      }
    },
    setPageView() {
      let uuid = this.$route.params.id;
      this.$axios.post("/work/updateBrowse", { uuid });
      // updateBrowse({ id })
      //   .then((res) => {})
      //   .catch((res) => {});
    },
    addWorkVisitCount() {
      // 添加作品訪問量
      const cid = "";//returnCitySN["cid"] ? returnCitySN["cid"] : "";
      this.$axios.post("/addVisit", {
        uuid: this.$route.params.id,
        province: cid.slice(0, 2) + "0000",
      });
      // addVisitCount({
      //   wid: this.$route.params.id,
      //   province: cid.slice(0, 2) + "0000",
      // });
    },
    //整合場景分組數據
    getGroupList(groups, scenes) {
      let res = [];
      for (let i = 0; i < groups.length; i++) {
        res[i] = {
          id: groups[i].id,
          name: groups[i].name,
          thumb_path: scenes[groups[i].scenes[0]].thumb_path,
        };
        let tmpsn = groups[i].scenes;
        let tmplist = [];
        for (let i2 = 0; i2 < tmpsn.length; i2++) {
          tmplist[i2] = {
            id: scenes[tmpsn[i2]].id,
            name: scenes[tmpsn[i2]].scene_title,
            thumb_path: scenes[tmpsn[i2]].thumb_path,
            scene_id: scenes[tmpsn[i2]].scene_id,
          };
        }
        res[i].sceneList = tmplist;
      }
      // console.log(res);
      return res;
    },
    //隱藏縮略圖
    hideTourThumbs(event) {
      this.toggleShowthumbs(false);
      window.clickAiPlay()
    },
    showTourThumbs() {
      this.toggleShowthumbs(true);
    },
    hideLoading() {
      this.loadingState = false;

      this.isMarqueeVivsble =
        this.newWork.ads.top_ad && this.newWork.ads.top_ad !== "";

      //傳遞沙盤top的值（暫時先寫這）
      let sptopNum = 10;
      if (!isMobile() && this.newWork.menus.length) {
        sptopNum = sptopNum + 50;
      }
      if (this.isMarqueeVivsble) {
        sptopNum = sptopNum + 30;
      }
      if (this.isVrTalk) {
        sptopNum += this.vrtalkH;
      }
      this.spTop = sptopNum + "px";

      if (this.firstLoad) {
        this.firstLoad = false;
        //if (!isMobile() && this.newWork.ads.cover.pc) {
        //  this.cover = this.newWork.ads.cover.pc;
        //} else if (isMobile() && this.newWork.ads.cover.mob) {
        //  this.cover = this.newWork.ads.cover.mob;
        //}
        if (this.cover != "") {
          //this.isShowSplash = true;
          setTimeout(() => {
            this.isShowSplash = false;
            if (this.newWork.sets.view_passwd != "") {
              this.passwordVisible = true;
            } else {
              this.toggleShowthumbs(true);
            }
          }, 2500);
        } else {
          if (this.newWork.sets.view_passwd != "") {
            this.passwordVisible = true;
          } else {
            this.toggleShowthumbs(true);
          }
        }
      } else {
        //進入新場景總是默認顯示場景縮略圖
        //this.toggleShowthumbs(true);
      }
    },
    updateCurrentScene() {
      console.log('觸發updateCurrentScene');
      this.$refs.thumbList.currentScene = this.krpanoObj.get("xml.scene");
      if(this.tongPingState){
        this.createKrpanoObj2(this.krpanoObj.get("xml.scene"));
      }
      this.setActivePano('pano');
    },
    toggleVoiceHotspot(sceneId, hotspotId) {
      let scene = this.newWork.scenes[sceneId];
      let hotspot = scene.hotspot[hotspotId];
      if (this.hotspotVoiceState && this.voiceHotspotId == hotspotId) {
        removeHotspot(hotspotId);
        addTourHotspot(hotspot);
        krToggleHotspotVoice(false);
        this.hotspotVoiceState = false;
        this.voiceHotspotId = "";
        this.toggleMusic(true);
      } else {
        this.hotspotVoiceState = true;
        this.voiceHotspotId = hotspotId;
        Object.keys(scene.hotspot).forEach((key) => {
          if (key != hotspotId && scene.hotspot[key].type == "audio") {
            removeHotspot(key);
            addTourHotspot(scene.hotspot[key]);
          }
        });
        removeHotspot(hotspotId);
        addTourHotspot({
          ...hotspot,
          ...{ icon_url: "/images/kr/playing.png", is_dynamic: true },
        });
        krToggleHotspotVoice(true, hotspot.content.url);
        this.toggleMusic(false);
      }
      if (this.isVrTalk && this.vrController) {
        this.socketSendMessage({ cmd: 100015, data: { sceneId: sceneId, hotspotId: hotspotId } });
      }
    },
    judgeMobile() {
      return isMobile();
    },

    //創建同屏
    createKrpanoObj2(sceneId) {
      if (this.tongPingState) {
        let tongPingData = this.newWork.scenes[sceneId].tongping;
        if (tongPingData && Object.keys(tongPingData).length > 1) {
          //移除舊的krpanoSWFObject2
          // let oldKrpano = document.getElementById("krpanoSWFObject2");
          // if (oldKrpano) {
          //   oldKrpano.parentNode.removeChild(oldKrpano);
          // }
          removepano("krpanoSWFObject2");
          let krsettings = {
            "autorotate.enabled": true, //自動旋轉
            "autorotate.speed": "1.5", //速度
          };
          embedpano({
            swf: "/ssr/static/tour/tour.swf",
            xml: `/api/tourXml?uuid=${this.newWork.base.uuid}&scene_id=${tongPingData.scene_id}`,
            target: "pano2",
            html5: "prefer+preserveDrawingBuffer",
            wmode: 'opaque-flash',
            mobilescale: 0.7,
            vars: krsettings,
            id: "krpanoSWFObject2",
          });
          this.krpanoObj2 = document.getElementById("krpanoSWFObject2");
          this.krpanoObj2.call('loadscene(' + tongPingData.scene_id + ', null, MERGE, BLEND(0.5));');
          this.tongPing();
        } else {
          this.$message.error('當前場景未設置對比圖')
          this.cleanTongPing();
        }
      }
    },
    clickTongPing() {
      let tongPingState = !this.tongPingState;
      this.toggleTongping(tongPingState);
      //關閉對比圖時，設定回來是'pano'
      if(!this.tongPingState){
        this.activePano = "pano"
      }
    },

    //開啟關閉同屏
    toggleTongping(tongPingState) {
      this.tongPingState = tongPingState
      if (this.tongPingState) {
        this.panoStyle = { width: "50%", height: "100%" };
        this.pano2Style = { display: "block", width: "50%", height: "100%" };
        this.panoBoxStyle = { ...this.panoBoxStyle, flexDirection: "row" };
        this.renderResize();
        this.createKrpanoObj2(this.krpanoObj.get('xml.scene'));
      } else {
        this.cleanTongPing();
        this.renderResize();
      }
    },
    //判斷使用者現在滑鼠點哪邊
    setActivePano(panoId) {
      if (this.tongPingState) {
        this.activePano = panoId;
        //判斷完呼叫同屏函式
        this.tongPing();
      }
    },
    //同屏實現
    tongPing() {
      let _this = this;
      //現在角度
      let angle2 = this.newWork.scenes[this.krpanoObj.get('xml.scene')].tongping.angle.initview
      if (this.tongPingInterval != null) {
        clearInterval(this.tongPingInterval);
      }
      //如果是pano，則更新左邊同屏
      if (this.activePano === "pano") {
        this.tongPingInterval = setInterval(function () {
          let angle1 = getSceneViewParamsById(_this.krpanoObj);
          //初始角度
          let oldAngle =
            _this.newWork.scenes[_this.krpanoObj.get("xml.scene")].angle;
          let hMove = angle1.hlookat - oldAngle.initview.hlookat;
          let hlookat = hMove + angle2.hlookat;
          let vMove = angle1.vlookat - oldAngle.initview.vlookat;
          let vlookat = vMove + angle2.vlookat;
          let fov = angle1.fov;
          setSceneViewParamsById({ vlookat, hlookat, fov }, _this.krpanoObj2);
        }, 15);
      } else if (this.activePano === "pano2") {
        this.tongPingInterval = setInterval(function () {
          let angle1 = getSceneViewParamsById(_this.krpanoObj2);
          let oldAngle =
            _this.newWork.scenes[_this.krpanoObj.get("xml.scene")].angle;
          let hMove = angle1.hlookat - oldAngle.initview.hlookat;
          let vMove = angle1.vlookat - oldAngle.initview.vlookat;
          let hlookat = angle2.hlookat + hMove;
          let vlookat = angle2.vlookat + vMove;
          let fov = angle1.fov;
          setSceneViewParamsById({ vlookat, hlookat, fov }, _this.krpanoObj);
        }, 15);
      }
    },
    //關閉初始化
    cleanTongPing() {
      this.pano2Style = { display: "none", width: "50%", height: "100%" };
      this.panoStyle = { width: "100%" };
      this.panoBoxStyle = { ...this.panoBoxStyle, flexDirection: "row" };
      clearInterval(this.tongPingInterval);
      removepano("krpanoSWFObject2");
      this.tongPingState = false;
      this.krpanoObj2 = null;
    },
    renderResize() {
      // 判斷橫豎屏
      let width = document.documentElement.clientWidth
      let height = document.documentElement.clientHeight
      if (this.tongPingState) {
        if (width < height) {
          this.panoStyle = { width: "100%", height: "50%" };
          this.pano2Style = { width: "100%", height: "50%", display: "block" };
          this.panoBoxStyle = { ...this.panoBoxStyle, flexDirection: "column" };
        } else {
          this.panoStyle = { width: "50%", height: "100%" };
          this.pano2Style = { width: "50%", height: "100%", display: "block" };
          this.panoBoxStyle = { ...this.panoBoxStyle, flexDirection: "row" };
        }
      } else {
        if (width < height) {
          this.panoStyle = { width: "100%", height: "100%" };
          this.pano2Style = { width: "100%", height: "100%", display: "none" };
         this.panoBoxStyle = { ...this.panoBoxStyle, flexDirection: "column" };
        } else {
          this.panoStyle = { width: "100%", height: "100%" };
          this.pano2Style = { width: "100%", height: "100%", display: "none" };
           this.panoBoxStyle = { ...this.panoBoxStyle, flexDirection: "row" };
        }
      }
    },

    // socket發送消息
    socketSendMessage(data) {
      // console.log("===socketSendMessage====", this.socket, data);
      const params = { ...data, userRoomId: this.userRoomId, scene: this.currentScenesId }
      this.socket && this.socket.send(params)
    },
    //接收websocket消息【只有被帶看人才監聽消息並更新】
    setNoticeData(result, targetId = -1) {
      if (!this.isInitFinished) {
        this.initEventqueue.push(result);
        return;
      }
      // if (result.cmd >= 0) {
      const { scene } = result;
      if (!this.vrController && result.userRoomId == targetId && scene && this.currentScenesId != scene) {
        // console.log("場景切換====", scene);
        this.$store.dispatch("loadScene", scene);
        // this.$store.dispatch("setCurrentScnId", sceneId);
        this.handleSandboxShow(scene);
      }

      if (!this.vrController && result.cmd == 1 && result.userRoomId == targetId) {
        // 1、角度切換
        setSceneViewParams(result.data);
      } else if (!this.vrController && result.cmd == 2 && result.userRoomId == targetId) {
        // 2、場景切換
        const sceneId = result.data;
        if (sceneId) {
          // console.log("2、場景切換====", sceneId);
          this.$store.dispatch("loadScene", sceneId);
          // this.$store.dispatch("setCurrentScnId", sceneId);
          this.handleSandboxShow(sceneId);
        }
      } else if (!this.vrController && result.cmd == 3 && result.userRoomId == targetId) {
        // 3、沙盤切換
        const isOn = result.data;
        this.isSandSceneVisible = isOn == 1;
      } else if (!this.vrController && result.cmd == 4 && result.userRoomId == targetId) {
        // 4、音樂開關
        const isMusicOn = result.data;
        this.toggleMusic(isMusicOn);
      } else if (!this.vrController && result.cmd == 12 && result.userRoomId == targetId) {
        // 12、解說開關
        const isSpeechOn = result.data;
        this.toggleSpeech(isSpeechOn);
      }
      //沙盤放大縮小
      else if (!this.vrController && result.cmd == 100010 && result.userRoomId == targetId) {
        this.sandTableZoomIn(result.isZoomIn)
      }
      //圖片熱點
      else if (!this.vrController && result.cmd == 100011 && result.userRoomId == targetId) {
        if (result.data.state == "open") {
          this.showImgHotspot(result.data.sceneId, result.data.hotspotId)
        }
        if (result.data.state == "close") {
          $.fancybox.close();
        }
      }
      //圖文熱點
      else if (!this.vrController && result.cmd == 100012 && result.userRoomId == targetId) {
        if (result.data.state == "open") {
          this.showPictextHotspot(result.data.title, result.data.content)
        }
        if (result.data.state == "close") {
          this.pictextHotspotVisible = false;
        }
      }
      //文字熱點
      else if (!this.vrController && result.cmd == 100013 && result.userRoomId == targetId) {
        if (result.data.state == "open") {
          this.showWordHotspot(result.data.title, result.data.content)
        }
        if (result.data.state == "close") {
          this.wordHotspotVisible = false;
        }
      }
      //視頻熱點
      else if (!this.vrController && result.cmd == 100014 && result.userRoomId == targetId) {
        if (result.data.state == "open") {
          console.log("showVideoHotspot====1", result)
          this.showVideoHotspot(result.data.url)
        }
        if (result.data.state == "close") {
          this.videoHotspotVisible = false;
          this.onVideoClose();
        }
      }
      //語音熱點
      else if (!this.vrController && result.cmd == 100015 && result.userRoomId == targetId) {
        this.toggleVoiceHotspot(result.data.sceneId, result.data.hotspotId)
      } else if (result.cmd == 0 && result.userRoomId == targetId) {
        // 0初始化，設置場景狀態
        // console.log("cmd === 0", result);
        const data = result.data;

        if (!this.vrController) {
          // 初始化場景切換
          const { scene } = data;
          if (scene) {
            // console.log("場景切換====", scene);
            this.$store.dispatch("loadScene", scene);
            // this.$store.dispatch("setCurrentScnId", sceneId);
            this.handleSandboxShow(scene);
          }
          // 初始化角度切換
          const { fov, hlookat, vlookat } = data;
          setSceneViewParams(result.data);
          // 初始化沙盤設置
          const { sandswitch } = data;
          sandswitch && (this.isSandSceneVisible = sandswitch == 1);
          // 4、音樂開關
          const { musicstate } = data;
          this.toggleMusic(musicstate);
        }

        // // 處理用戶列表
        const { user_list } = data;
        if (user_list) {
          this.handleUSerList(user_list);
        }
      } else if (result.cmd == 104) {
        // 用戶狀態變更
        const data = result.data;
        this.handleUSerList(data);
      }
      // }
    },
    showThingBase() {
      this.isShowThingBase = !this.isShowThingBase;
    },
    closeThingBase() {
      this.isShowThingBase = false;
    },
    goToMore() {
      let url;
      if (this.newWork.base.store_type == 1) {
        url = 'https://www.great-home.com.tw/detail/?sn=' + this.newWork.base.thing_no;
      } else {
        url = 'https://www.hbhousing.com.tw/detail/?sn=' + this.newWork.base.thing_no;
      }
      // console.log(url);
      window.open(url, 'target');
    },
    handleResize() {
      this.sandTableHeight = document.documentElement.clientHeight * 0.27;
      this.aiAnchorHeight = document.documentElement.clientHeight;
    },
  },
  created() {
    // let height = `${document.documentElement.clientHeight}`;
    // this.winFullHeight = parseInt(height);
  },
  mounted() {
    //created內容遷移-start
    let height = `${document.documentElement.clientHeight}`;
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.winFullHeight = parseInt(height);
    //created內容遷移-end
    if (isMobile()) {
      this.showBaseBtnByMobile = true;
    }
    if (this.offLine) {
      this.workInit();
    }
    else {
      this.lineAppid()
      const id = this.$route.params.id;

      this.workInit();
      this.setPageView();
      this.addWorkVisitCount();
      // 獲取linecode
      this.lineLoginInit()
      //如果url有傳遞code參數，則執行微信登陸
      if (this.$route.query.code) {
        if (process.client) {
          let type =
            window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
              "micromessenger"
              ? "wx"
              : "wxweb";
          this.$axios
            .post("/wechat/wxLogin", { code: this.$route.query.code, type: type })
            .then((res) => {
              if (res.code == 1 && res.data) {
                this.$store.commit("SET_WX_USER_INFO", res.data);
              }
            })
            .catch((err) => {
              //todo
            });
        }
      }
    }

    //將方法掛載到window對像
    window.tourHideThumbs = this.hideTourThumbs;
    window.tourHideLoading = this.hideLoading;
    window.tourUpdateCurrentScene = this.updateCurrentScene;
    window.tourShowThumbs = this.showTourThumbs;
    window.show_comment_list = this.show_comment_list;
    window.toggleBtns = this.toggleBtns;
    window.onCloseImgHotspot = this.onCloseImgHotspot;

    this.InitAi();
    this.parentWidth = document.querySelector('body').clientWidth;
    console.log('parentWidth:', this.parentWidth);
  },
};
</script>
<style lang="less">
.iframeRWD {
  height: 562px;
}

.iframeRWD.iframeVideo {
  height: 323px;
}

.ant-modal {
  padding-bottom: 0;
}

.ant-modal-content {
  /*border-radius: 0;*/
  background-clip: initial;
}

@media (max-width: 767px) {
  .iframeRWD {
    height: 345px;
  }

  .textModal .ant-modal {
    max-width: calc(100vw - 30px);
  }

  .textModal .ant-modal-content,
  .shareModal .ant-modal-content {
    padding: 0 10px;
  }

  .textModal .ant-modal-body {
    padding: 16px 0;
  }

  .textModal .ant-modal-header,
  .shareModal .ant-modal-header {
    padding: 16px 26px 16px 4px;
  }

  .shareModal .ant-modal {
    max-width: calc(100vw - 60px);
  }
}
</style>
<style lang="less" scoped>
@-ms-viewport {
  width: device-width;
}

@media only screen and (min-device-width: 800px) {
  html {
    overflow: hidden;
  }
}

html {
  height: 100%;
}

body {
  height: 100%;
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  font-family: microsoft yahei, Helvetica, sans-serif;
  background-color: #000000;
}

.fullscreen-wrap {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 998;

  &.hasMenu {
    height: calc(100% - 48px);
  }
}

.marquee {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 800;
  overflow: hidden;
  height: 30px;
  line-height: 30px;
  color: white;
  background: rgba(0, 0, 0, 0.2);
}

/*帶看相關css*/
.mixin-homeowner-box {
  position: fixed;
  top: 10px;
  left: 10px;
  height: 46px;
  z-index: 1000;
  border-radius: 23px;
  background-color: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0 10px 0 5px;
  display: flex;
  align-items: center;

  .header-imgs {
    width: 36px;
    height: 36px;
    position: relative;
    flex-shrink: 0;

    .yy-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 14px;
      height: 14px;
      z-index: 10;
      font-size: 0;
    }

    .tx {
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
  }

  .texts {
    flex: 1;
    max-width: 24vw;
    padding: 0 10px;

    .names {
      font-size: 13px;
      color: #ffffff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .times {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .tips {
    flex-shrink: 0;
    height: 30px;
    border-radius: 15px;
    background-color: #ffffff;
    color: #666666;
    font-size: 12px;
    display: flex;
    align-items: center;
    padding: 0 10px;
  }
}

.mixin-participant-box {
  position: fixed;
  z-index: 1000;
  top: 66px;
  left: 10px;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 6px 6px 0 6px;

  .participant-list {
    width: 36px;
    height: 36px;
    overflow: hidden;
    border-radius: 5px;
    margin-bottom: 6px;
    position: relative;

    .tx {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }

    .yy-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 14px;
      height: 14px;
      z-index: 10;
      font-size: 0;
    }
  }
}

#sand {
  position: absolute;
  width: 45%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  .iframeRWD {
    height: 190px;
  }

  .card_content_text {
    max-height: 200px;
    overflow: auto;
  }
}

.pano {
  z-index: 999;
}

.splash {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  opacity: 1;
  // transition: opacity 0.5s ease;
  box-sizing: border-box;
  background: #ffffff;
  // &.fade-enter,
  // &.fade-leave-to {
  //   opacity: 0;
  // }
  background-position: center;
  background-size: cover;
}

.splash img {
  position: absolute;
  width: 100%;
  height: 100%;
}

.slide-fade-enter-active {
  transition: opacity 1s ease;
}

.slide-fade-leave-active {
  transition: opacity 1s;
}

// .slide-fade-enter
// /* .slide-fade-leave-active for below version 2.1.8 */ {
//   transform: translateX(-210px);
//   opacity: 0;
// }

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */
  {
  opacity: 0;
}

.comment-modal {
  bottom: 20px;
  left: 50%;
  margin-right: -50%;
  transform: translateX(-50%);
  position: absolute;
  z-index: 4300;
  width: 400px;
  height: 179px;
  padding: 12px 15px;
  background-color: rgba(51, 51, 51, 0.7);
  color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  .comment-title {
    margin-bottom: 10px;
    font-size: 16px;
    display: flex;
    align-items: center;

    img {
      display: inline-block;
      vertical-align: top;
      width: 17px;
      height: 16px;
      margin-right: 10px;
    }
  }

  .comment-footer {
    display: flex;
    margin: 15px 0;
    color: #ffffff;

    .footer-left {
      flex: 1;
      display: flex;

      .option {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          display: inline-block;
          vertical-align: top;
          width: 16px;
          height: 15px;
        }

        span {
          display: inline-block;
          // vertical-align: middle;
          margin-left: 5px;
        }
      }

      .fix-gap {
        margin-left: 10px;
      }
    }

    .footer-right {
      flex: 1;
      display: flex;
      justify-content: flex-end;

      .cancel-btns {
        margin-left: 10px;
      }
    }
  }
}

@media (max-width: 767px) {
  .comment-modal {
    bottom: 48px;
    width: 86%;
    height: 179px;

    .comment-title {
      font-size: 14px;

      img {
        width: 15px;
        height: 14px;
        margin-right: 8px;
      }
    }

    .comment-footer {
      .footer-left {
        .option {
          img {
            width: 12px;
            height: 11px;
          }

          span {
            font-size: 12px;
            margin-left: 5px;
          }
        }

        .fix-gap {
          margin-left: 10px;
        }
      }

      .footer-right {
        flex: 1;
        display: flex;
        justify-content: flex-end;

        .cancel-btns {
          margin-left: 10px;
          font-size: 12px;
        }

        .fb-btns {
          font-size: 12px;
        }
      }
    }
  }
}

.ql-editor {
  overflow-y: scroll;
}

::v-deep .ql-editor img {
  display: inline-block;
  max-width: 100%;
}

// .fade-enter-active,
// .fade-leave-active {
//   // transition: opacity 1.5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }

.sand-box-tour-base {
  position: absolute;
  right: 65px;
  padding: 0;
  /*10px;*/
  background-color: rgba(255, 255, 255, 0.4);
  -webkit-transform-origin: top right;
  -ms-transform-origin: top right;
  transform-origin: top right;
  z-index: 998;
  // width: 200px;
  // max-width: 600px;
  // max-height: 600px;
}

.sand-box-tour-base-zmin {
  position: absolute;
  top: 5px;
  padding: 0;
  /*10px;*/
  background-color: rgba(255, 255, 255, 0.4);
  -webkit-transform-origin: top right;
  -ms-transform-origin: top right;
  transform-origin: top right;
  z-index: 998;
  transform: translate(-50%, 0);
  left: 50%;
}

@media screen and (max-device-width: 768px) {
  .sand-box-tour-base {
    position: absolute;
    top: 0;
    right: 50px;
    padding: 0;
    /*10px;*/
    background-color: rgba(255, 255, 255, 0.4);
    -webkit-transform-origin: top right;
    -ms-transform-origin: top right;
    transform-origin: top right;
    z-index: 998;
    // width: 150px;
    // max-width: 300px;
    // max-height: 300px;
  }

  .sand-box-tour-base-zmin-m {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    padding: 0;
    /*10px;*/
    background-color: rgba(255, 255, 255, 0.4);
    z-index: 998;
  }
}

#loading {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 99999;
  background: rgb(0, 0, 0);
  top: 0px;
  left: 0px;
  text-align: center;

  img {
    height: 30px;
    margin: 0 auto;
  }
}

//帶看時，被帶看者屏幕遮罩
.vr-show-cover {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1001;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
}

.thing-base-box {
  z-index: 1001;
  position: absolute;
  top: 50px;
  left: calc(50% - 250px);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  height: 50px;
  background: linear-gradient(to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.7) 50%,
      rgba(255, 255, 255, 0) 100%);

  .thing-name-box {
    display: flex;

    .base-title {
      //background-color: #22b24c;
      color: #ffffff;
      border-radius: 50px;
      margin-left: 20px;
      font-size: 12px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    //align-items: center;
  }
}

.thing-base-panel {
  z-index: 1001;
  position: absolute;
  top: 150px;
  left: calc(50% - 300px);
  width: 600px;
  background: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  padding: 20px;
  border-radius: 10px;

  .panel-header {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .look-more {
      display: flex;
    }
  }

  .line-header {
    width: 100%;
    height: 1px;
    margin-top: 15px;
    background: linear-gradient(to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.7) 50%,
        rgba(255, 255, 255, 0) 100%);
  }

  .panel-body {
    display: flex;
    //justify-content: space-between;
    margin-top: 20px;

    .base-box {
      display: flex;
      flex-direction: column;
      width: 50%;

      .base-item {
        padding: 10px 0;
        display: flex;

        .item-title {
          width: 60px;
        }

        .item-value {
          margin-left: 30px;
        }
      }
    }
  }
}

//過期提示框
.overdue-tips-box {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);

  .box-content {
    width: 320px;
    background-color: #ffffff;
    position: relative;
    border-radius: 8px;
    overflow: hidden;

    .close-btns {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fdacac;
      border-radius: 0 0 0 15px;

      .icon-ants {
        font-size: 16px;
        color: #ffffff;
        transform: rotate(45deg);
      }
    }

    .tops {
      display: flex;
      justify-content: center;
      padding: 0 0 20px 0;
      height: 200px;
      background-color: #fff5f5;

      img {
        max-width: 100%;
        height: 100%;
      }
    }

    .bottoms {
      padding: 20px;
      text-align: center;

      h1 {
        font-size: 24px;
        margin-bottom: 5px;
      }
    }
  }
}

@media (max-width: 767px) {
  .overdue-tips-box {
    .box-content {
      width: 60%;

      .tops {
        height: 160px;
      }
    }
  }
}

@media (max-width: 767px) {
  .thing-base-panel {
    position: absolute;
    left: calc(50% - 170px);
    width: 340px;

    .panel-body {
      .base-box {
        .base-item {
          //width: 50px;
        }
      }
    }
  }
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 800;
  pointer-events: none;
}
</style>
